export function runIf(predicate: (instance: any) => boolean) {
    return function (originalMethod: any, context: ClassMethodDecoratorContext) {
        return function (this: any, ...args: any[]) {
            if (predicate(this)) {
                return originalMethod.apply(this, args);
            }
        };
    };
}
